import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ButtonComponent, TooltipDirective } from '@pure/hive';
import { EoscRenewal } from '../../../../data/models/recommendations.models';

/**
 * The Renew button for an end-of-support-contract recommendation. It is disabled without
 * permission, which the tooltip explains, and while another action is in progress.
 */
@Component({
    selector: 'eosc-renew-button',
    templateUrl: './eosc-renew-button.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [ButtonComponent, TooltipDirective],
})
export class EoscRenewButtonComponent {
    readonly eosc = input.required<EoscRenewal>();
    readonly actionInProgress = input(false);

    readonly renew = output<void>();

    protected readonly tooltip = computed(() => (this.eosc().allowRenew() ? '' : 'Operation not permitted'));
}
